import React, { Fragment } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import parse from 'html-react-parser';

const CarouselSettings = {
    showStatus: false,
    showThumbs: false,
    infiniteLoop: true,
    emulateTouch: true,
    interval: 5000
};

const Slider = ({ values, settings }) => {
    var showDots = values.length != 1;
    CarouselSettings.showIndicators = showDots;
    var autoPlay = settings.length > 0 ? settings[0].dataset.autoplay : true;
    CarouselSettings.autoPlay = autoPlay == true ? true : false;

    return (
        <Carousel {...CarouselSettings}>
            {values.map((value, index) => (
                <div key={`figure${index}`} className={value.pdp ? "slider__image-wrapper" : ""}>
                    {value.pdp
                        ? <img className="slider__image-container slider__image-container-pdp" alt={value.alt} src={value.image} />
                        : <span className="slider__image-container" role="img" aria-label={value.alt} style={{ backgroundImage: "url(" + value.image + ")" }}></span>
                    }
                    <div className="banner-text">
                        <div className="row">
                            <div className="small-12 large-6 columns">
                                <h2>{value.title}</h2>
                                {parse(value.text)}
                                <h3 className="banner-text__title"><a href={value.url}>{value.linkText}</a></h3>
                                {value.actionText && value.actionText.length > 0 && (
                                    <a className="banner-text__button" href={value.url}>
                                        {value.actionText}
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </Carousel>
    );
};

export default Slider;
